import { AxiosInstance } from 'axios'
import { IJsonApiSerializer } from '../JsonApiSerializer'

class PostCalendarService {
  public httpClient: AxiosInstance
  public serializer: IJsonApiSerializer

  constructor(httpClient: AxiosInstance, serializer: IJsonApiSerializer) {
    this.httpClient = httpClient
    this.serializer = serializer
  }

  public async getCalendars(postId, params) {
    const { data } = await this.httpClient.get(`/api/posts/${postId}/calendars`, {
      params,
    })
    const {
      calendars: { data: calendars },
    } = data

    return { calendars }
  }

  public async getCalendarsWithPast(postId, params) {
    const { data } = await this.httpClient.get(`/api/posts/${postId}/calendars/index_for_direct`, {
      params,
    })
    const {
      calendars: { data: calendars },
    } = data

    return { calendars }
  }
}

export default PostCalendarService
